import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const RefundPolicy = () => (
  <div className="min-h-screen bg-[#050505]">
    <Navbar />
    <section className="pt-28 pb-16">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <h1 className="text-3xl font-black font-heading text-white mb-8">Payment & Refund Policy</h1>
        <div className="prose prose-invert prose-zinc max-w-none space-y-6 text-sm text-zinc-400 leading-relaxed">
          <h2 className="text-xl font-bold text-white mt-8">1. Payment Terms</h2>
          <p>Payment is for participation in a trading evaluation program. All fees are charged at the time of purchase and grant immediate access to the evaluation environment.</p>
          <h2 className="text-xl font-bold text-white mt-8">2. Refund Eligibility</h2>
          <p>Refund requests may be submitted within 24 hours of purchase if no trades have been placed on the evaluation account. Once trading activity has commenced, the evaluation fee is non-refundable.</p>
          <h2 className="text-xl font-bold text-white mt-8">3. Account Breach</h2>
          <p>If an evaluation account is breached due to rule violations, the evaluation fee is not refundable. A new evaluation may be purchased at the applicable rate.</p>
          <h2 className="text-xl font-bold text-white mt-8">4. Processing Time</h2>
          <p>Approved refunds are processed within 5-7 business days and returned via the original payment method (cryptocurrency).</p>
          <h2 className="text-xl font-bold text-white mt-8">5. Dispute Resolution</h2>
          <p>For any payment disputes or concerns, please contact our support team at ayronnsupport@gmail.com. We aim to resolve all inquiries within 48 hours.</p>
        </div>
      </div>
    </section>
    <Footer />
  </div>
);

export default RefundPolicy;
